import { createApi } from '@reduxjs/toolkit/query/react'
import { hcPortalBaseQuery } from '@/features/baseQuery.ts'
import {
  AddTeamRequest,
  DeleteTeamRequest,
  EditTeamRequest,
  GetTeamRequest,
  SearchTeamsRequest,
} from '@/features/team/team-request.def.ts'
import { GetTeamResponse } from '@/features/team/team-response.def.ts'


export const teamApi = createApi({
  reducerPath: 'teamApi',
  baseQuery: hcPortalBaseQuery(),
  tagTypes: ['Team'],
  endpoints: builder => ({
    getTeams: builder.query<GetTeamResponse[], void>({
      query: () => ({
        url: '/Team/GetTeams',
        method: 'GET',
        cache: 'no-cache',
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: 'Team' as const, id })),
            { type: 'Team' as const, id: 'LIST' },
          ]
          : [{ type: 'Team' as const, id: 'LIST' }],
    }),
    getTeam: builder.query<GetTeamResponse, GetTeamRequest>({
      query: (request) => ({
        url: '/Team/GetTeam',
        method: 'GET',
        cache: 'no-cache',
        params: request,
      }),
      providesTags: (_result, _error, request) => [{ type: 'Team', id: request.id }],
    }),
    searchTeams: builder.query<GetTeamResponse[], SearchTeamsRequest>({
      query: (request) => ({
        url: '/Team/SearchTeams',
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: 'Team' as const, id })),
            { type: 'Team' as const, id: 'LIST' },
          ]
          : [{ type: 'Team' as const, id: 'LIST' }],
    }),
    addTeam: builder.mutation<boolean, AddTeamRequest>({
      query: (request) => ({
        url: '/Team/AddTeam',
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
      invalidatesTags: [{ type: 'Team', id: 'LIST' }],
    }),
    editTeam: builder.mutation<boolean, EditTeamRequest>({
      query: (request) => ({
        url: '/Team/EditTeam',
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
      invalidatesTags: (_result, _error, request) => [
        { type: 'Team', id: request.id },
        { type: 'Team', id: 'LIST' },
      ],
    }),
    deleteTeam: builder.mutation<boolean, DeleteTeamRequest>({
      query: (request) => ({
        url: '/Team/DeleteTeam',
        method: 'POST',
        cache: 'no-cache',
        body: request,
      }),
      invalidatesTags: (_result, _error, request) => [
        { type: 'Team', id: request.id },
        { type: 'Team', id: 'LIST' },
      ],
    }),
  }),
})

export const {
  useGetTeamsQuery,
  useGetTeamQuery,
  useSearchTeamsQuery,
  useAddTeamMutation,
  useEditTeamMutation,
  useDeleteTeamMutation,
} = teamApi
